export default {
  wechatUser: { // 微信用户信息
    subscribe: window.subscribe
  },
  shareInfo: {
    title: '',
    desc: '',
    imgUrl: '',
    columnName: ''
  },
  wxConfigSuccess: false,
  serviceConfig: {}
}